<template>
  <button
    class="btn"
    :class="{
      'btn-black': black,
      'btn-icon': icon,
      'btn-light': light,
      'btn-primary': primary,
      'icon-only': iconOnly,
      'icon-off-mobile': iconOffMobile,
      'btn-block': block,
      'active': active
    }"
    type="button"
    :disabled="loading"
    v-on="$listeners"
  >
    <div v-if="icon || loading" class="icon">
      <Loader v-if="loading" :size="28" />
      <img v-else :src="icon">
    </div>
    <span class="btn-inner">
      <slot />
    </span>
  </button>
</template>

<script>
import Loader from './loader'

export default {
  name: 'BBtn',
  components: {
    Loader
  },
  props: {
    active: {
      type: Boolean,
      required: false,
      default: false
    },
    black: {
      type: Boolean,
      required: false,
      default: false
    },
    block: {
      type: Boolean,
      required: false,
      default: false
    },
    iconOffMobile: {
      type: Boolean,
      required: false,
      default: false
    },
    iconOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    icon: {
      type: String,
      required: false,
      default: null
    },
    light: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    primary: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>